export const GET_ERRORS = 'GET_ERRORS'
export const CLEAR_ERRORS = 'CLEAR_ERRORS'
export const USER_LOADING = 'USER_LOADING'
export const GET_CURRENT_USER = 'GET_CURRENT_USER'
export const SET_CURRENT_USER = 'SET_CURRENT_USER'
export const DELETE_CURRENT_USER = 'DELETE_CURRENT_USER'


// WEBPACK FOOTER //
// ./src/actions/types.js